import { t } from "@lingui/macro";

import { Button } from "@whoosh/design-system/src/components/controls";
import { Modal } from "@whoosh/design-system/src/components/overlay/Modal";
import {
  Box,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

type LocationItem = {
  id: string;
  name: string;
  bucketName?: string | null;
};

type EventLocationsModalProps = {
  isOpen: boolean;
  onClose: () => void;
  locations: LocationItem[];
};

export const EventLocationsModal = ({
  isOpen,
  onClose,
  locations,
}: EventLocationsModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      {!isOpen ? null : (
        <Box
          overflow="hidden"
          borderRadius={{ base: "0", md: "4" }}
          width={{ base: "100%", md: 320 }}
          backgroundColor="surface-primary"
        >
          <VStack
            gap={4}
            paddingHorizontal={6}
            paddingTop={6}
            paddingBottom={2}
          >
            <Text variant="mainHeading">{t`Event Locations`}</Text>
            <VStack>
              {locations.map((location) => (
                <Text
                  key={location.id}
                  variant="mainBaseMedium"
                  color="text-secondary"
                >
                  {location.bucketName
                    ? `${location.bucketName} · ${location.name}`
                    : location.name}
                </Text>
              ))}
            </VStack>
          </VStack>
          <Box
            paddingHorizontal={6}
            paddingTop={4}
            paddingBottom={6}
            flexDirection="row"
            justifyContent="flex-end"
          >
            <Button
              variant="secondary"
              size="small"
              onPress={onClose}
              accessibilityLabel={t`Close`}
            >
              {t`Close`}
            </Button>
          </Box>
        </Box>
      )}
    </Modal>
  );
};
